import { /*RegistrationScreen3,*/ TermOfUse } from './registrationScreens';
// import Verification from './accountVerification';
// import Testing from './components/Testing';
// import Testing2 from './components/Testing2';
import LinkPolicyScreen from './components/LinkPolicyScreen';
import RegisterUserInfoScreen from './components/RegisterUserInfoScreen';
import AccountAccessScreen from './components/AccountAccessScreen';
import EmailSentScreen from './components/EmailSentScreen';

const registrationScreen1 = {
  name: 'registrationScreen1',
  url: '/associate-policy',
  component: LinkPolicyScreen,
};

const registrationScreen2 = {
  name: 'registrationScreen2',
  url: '/registration',
  component: RegisterUserInfoScreen,
};

const registrationScreen3 = {
  name: 'registrationScreen3',
  url: '/registration-success',
  component: EmailSentScreen,
};

const verifyAccount = {
  name: 'verifyAccount',
  url: '/verify/:userIdToken/:dateTimeToken/:emailToken',
  component: AccountAccessScreen,
};

const termOfUse = {
  name: 'termOfUse',
  url: '/term-of-use',
  component: TermOfUse,
};

export default [registrationScreen1, registrationScreen2, registrationScreen3, verifyAccount, termOfUse];
